import { Component } from '@angular/core';
import { TransfersActions } from '@app/client/account/team/transfers/actions';
import * as fromRoot from '@app/reducers';
import { Transfer } from '@app/shared/models/transfer';
import { DialogRef } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import * as fromTransferDetails from '../../reducers/transfer-details.reducer';

@Component({
  selector: 'app-modal-delete-transfer',
  templateUrl: './modal-delete-transfer.component.html',
  styleUrls: ['./modal-delete-transfer.component.scss']
})
export class ModalDeleteTransferComponent {

  transferDeleting$: Observable<boolean>;
  transferDeleted$: Observable<boolean>;

  transfer: Transfer;

  constructor(private store$: Store<fromRoot.State>, public ref: DialogRef) {
    this.transfer = this.ref.data.transfer;

    this.transferDeleting$ = this.store$.pipe(select(fromTransferDetails.getTransferDeleting));
    this.transferDeleted$ = this.store$.pipe(select(fromTransferDetails.getTransferDeleted));
  }

  onConfirmInactivate() {
    this.store$.dispatch(TransfersActions.deleteTransfer({ transferId: this.transfer.id }));
    this.transferDeleted$.pipe(first(deleted => deleted)).subscribe(() => this.close());
  }

  close() {
    this.ref.close();
  }

}
